/* Account API helpers — Phase 5b. Uses the shared axios instance. */
import { api } from "./api";

export const account = {
  updateProfile: (patch) => api.patch("/auth/me", patch).then(r => r.data),
  changePassword: (current_password, new_password) =>
    api.post("/auth/change-password", { current_password, new_password }).then(r => r.data),
  deleteAccount: (password) =>
    api.delete("/auth/me", { data: { password } }).then(r => r.data),
};

export const sessions = {
  list: () => api.get("/auth/sessions").then(r => r.data.sessions),
  revoke: (id) => api.delete(`/auth/sessions/${id}`).then(r => r.data),
  revokeAll: (keepCurrent = true) =>
    api.delete("/auth/sessions", { params: { keep_current: keepCurrent } }).then(r => r.data),
};

export const family = {
  me: () => api.get("/families/me").then(r => r.data),
  create: (name) => api.post("/families", { name }).then(r => r.data),
  leave: () => api.delete("/families/me").then(r => r.data),
  invite: (email, role = "member") => api.post("/families/invites", { email, role }).then(r => r.data),
  revokeInvite: (id) => api.delete(`/families/invites/${id}`).then(r => r.data),
  previewInvite: (token) => api.get(`/families/invites/${token}`).then(r => r.data),
  acceptInvite: (token) => api.post(`/families/invites/${token}/accept`).then(r => r.data),
  setRole: (memberId, role) => api.patch(`/families/members/${memberId}`, { role }).then(r => r.data),
  removeMember: (memberId) => api.delete(`/families/members/${memberId}`).then(r => r.data),
};

export const audit = {
  list: ({ rx_id, resource_type, limit = 20 } = {}) =>
    api.get("/audit", { params: { rx_id, resource_type, limit } }).then(r => r.data.events),
};

export const rxShare = {
  toggle: (rxId, isShared) =>
    api.post(`/prescriptions/${rxId}/family-share`, { is_shared: isShared }).then(r => r.data),
};
